var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({on:{"click":_vm.login}},'v-btn',_vm.$attrs,false),[_c('v-icon',{staticClass:"mr-1",attrs:{"dark":""}},[_vm._v("mdi-login-variant")]),_vm._v(" "+_vm._s(_vm.$t('Login'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }